module.exports = __webpack_public_path__ + "img/add.35b56454.svg";